import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import Stats from "../../components/Stats";
import { images, imagesAlt } from "../../utils/images";
import SpinnerLoader from "../../utils/SpinnerLoader";
import {
    coinsStackIcon, currentSpeedIcon, fuelPumpKpiIcon, healthShieldIcon,
    IdlingIcon, lastFuelVolIcon, odoMeterReadingIcon, refuelIcon, vehicleEfficiencyIcon
} from "../../utils/svgs";
import FuelCard from "./FuelCard";

const VehicleDescription = () => {

    const { loading, getVehicleDetailsByFuelLogData, getVehicleDetailsByFuelLogLoading } = useSelector((state) => state.fuel);

    const kpiStatsData = [
        {
            title: "Total Fuel Filled",
            value: getVehicleDetailsByFuelLogData?.performance_indicator?.totalFuelFilled,
            text: "Fuel in Liters",
            icon: fuelPumpKpiIcon,
            className: "stats_value_lg"
        },
        {
            title: "Total Refuel Cost",
            value: getVehicleDetailsByFuelLogData?.performance_indicator?.completeTotalFuelCost,
            text: "PKR (Currency)",
            icon: coinsStackIcon,
            className: "stats_value_lg"
        },
        {
            title: "Vehicle Efficiency",
            value: getVehicleDetailsByFuelLogData?.performance_indicator?.vehicleEfficiency,
            text: "Efficiency in km/L",
            icon: vehicleEfficiencyIcon,
            className: "stats_value_lg"
        },
        {
            title: "Idling Cost",
            value: getVehicleDetailsByFuelLogData?.performance_indicator?.idlingCost,
            text: "Fuel wasted in PKR",
            icon: IdlingIcon,
            className: "stats_value_lg"
        }
    ];

    const fuelReconciliationItems = [
        {
            icon: currentSpeedIcon,
            label: "Current Speed",
            unit: "Km/h",
            value: getVehicleDetailsByFuelLogData?.current_info?.speed,
        },
        {
            icon: odoMeterReadingIcon,
            label: "Odometer Reading",
            unit: "km/miles",
            value: getVehicleDetailsByFuelLogData?.current_info?.odm
        },
        {
            icon: lastFuelVolIcon,
            label: "Last Fuel Volume",
            unit: "ltrs",
            value: getVehicleDetailsByFuelLogData?.current_info?.fuel_volume,
        },
        {
            icon: refuelIcon,
            label: "Last Refuel Date",
            // unit: "PKR",
            value: getVehicleDetailsByFuelLogData?.current_info?.refuel_date || "N/A",
        }
    ];

    const currentFuelPercentage = getVehicleDetailsByFuelLogData?.fuel_level;

    if (getVehicleDetailsByFuelLogLoading || loading) {
        return <SpinnerLoader />
    }

    return (
        <div>
            <Row>
                <Col md={6}>
                    <FuelCard
                        title="Operational Status"
                        subtitle="Fuel Information for this trip record."
                        items={fuelReconciliationItems}
                    />
                </Col>
                <Col md={6}>
                    <div className="fuel_card_container">
                        <div className="fuel_card_header">
                            <div className="fuel_card_title_group">
                                <h4>Fuel Tank Level</h4>
                                <p>Fuel tank level for this trip record.</p>
                            </div>
                        </div>

                        <div className="fuel_tank_visual_container">
                            <img src={images.fuelTruck} alt={imagesAlt.fuelTruck} className="w-100" style={{ height: "190px", objectFit: "auto" }} />
                            <div className="fuel_overlay_text">
                                <h1>{currentFuelPercentage}%</h1>
                                <span>Current Fuel in Tank</span>
                            </div>
                        </div>
                    </div>
                </Col>

                <Col md={12}>
                    <div className="content_box mb-3">
                        <h6>Key Performance Indicators</h6>
                        <p>KPI Summary of Fuel and Vehicle</p>

                        <div className="fuel_card_container p-4 mb-4">
                            <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center gap-3">
                                    <div className="health_score_icon">
                                        {healthShieldIcon}
                                    </div>
                                    <div>
                                        <h6 className="mb-2" style={{ fontSize: '15px', color: '#3b3f5c', fontWeight: 600 }}>Vehicle's Operational Health Score</h6>
                                        <div className="health_score_legend d-flex gap-0">
                                            <span className="legend_item critical">Critical <span>00-20</span></span>
                                            <span className="legend_item poor">Poor <span>21-40</span></span>
                                            <span className="legend_item fair">Fair <span>41-60</span></span>
                                            <span className="legend_item good">Good <span>61-80</span></span>
                                            <span className="legend_item excellent">Excellent <span>81-100</span></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex align-items-center gap-3">
                                    <span className="health_score_value">{getVehicleDetailsByFuelLogData?.performance_indicator?.healthScore}</span>
                                    {(() => {
                                        const score = getVehicleDetailsByFuelLogData?.performance_indicator?.healthScore || 0;
                                        let status = { label: "N/A", color: "#6B7280" }; // Default gray

                                        if (score >= 0 && score <= 20) status = { label: "Critical", color: "#EF4444" };
                                        else if (score > 20 && score <= 40) status = { label: "Poor", color: "#F97316" };
                                        else if (score > 40 && score <= 60) status = { label: "Fair", color: "#EAB308" };
                                        else if (score > 60 && score <= 80) status = { label: "Good", color: "#4F46E5" };
                                        else if (score > 80 && score <= 100) status = { label: "Excellent", color: "#22C55E" };

                                        return (
                                            <span className="health_score_badge" style={{ color: status.color, borderColor: status.color + '20', backgroundColor: status.color + '10' }}>
                                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <circle cx="6" cy="6" r="6" fill={status.color} />
                                                    <path d="M3.5 6L5 7.5L8.5 4" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                                {status.label}
                                            </span>
                                        );
                                    })()}
                                </div>
                            </div>
                        </div>

                        {/* Stats Grid */}
                        <Stats statsData={kpiStatsData} />
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default VehicleDescription
